export default __webpack_public_path__ + "static/media/PersImg27.f62cdaca.jpg";